import axios from 'axios';
import { startLoading, stopLoading } from './loaderBus';
import { installTokenRefresh } from './tokenRefresh';

const API = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api'
});

// Every request/response through this instance reports to the global
// loader (see components/GlobalLoader.jsx) so pages don't need their own
// spinners just to show that an API call is in flight.
API.interceptors.request.use((req) => {
    const token = localStorage.getItem('adminToken');
    if (token) req.headers.Authorization = `Bearer ${token}`;
    startLoading();
    return req;
}, (error) => {
    stopLoading();
    return Promise.reject(error);
});

API.interceptors.response.use((res) => {
    stopLoading();
    return res;
}, (error) => {
    stopLoading();
    return Promise.reject(error);
});

// an expired admin token is swapped for a fresh one automatically (added last, so the loader above has already been stopped)
installTokenRefresh(API);

export default API;